import React from "react";

import DataSvg from "../../assets/images/icons/Data output.svg";

export const DataOutputIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={DataSvg}
        alt={alt || "Data Output"}
    />
);
